
















































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import {
  IAccountMembershipsOutputDetail,
  IPersonWithEmail,
} from '@/api/types/response.types'

/* API */
import AccountMembershipsAPI from '@/api/modules/account-memberships.api'

export default Vue.extend({
  name: 'DeletePersonModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    person: {
      type: Object as () => IAccountMembershipsOutputDetail,
      required: true,
    },
  },

  data() {
    return {
      isLoading: true,
      isDeletingPerson: false,
      userIDToReassignItemsTo: null,
      deleteConfirmed: false,
      reassignablePeople: [] as IPersonWithEmail[],
    }
  },

  computed: {
    internalShowModal: {
      get(): boolean {
        return this.showModal
      },
      set(newValue: boolean) {
        this.$emit('update:showModal', newValue)
      },
    },
    userToReassignItemsTo(): IPersonWithEmail {
      return this.reassignablePeople.find(
        p => p.id === this.userIDToReassignItemsTo,
      )
    },
    isDeleteSubmitDisabled(): boolean {
      return !(this.userIDToReassignItemsTo && this.deleteConfirmed)
    },
  },

  watch: {
    internalShowModal: {
      async handler(value) {
        if (value) {
          this.isLoading = true
          await this.fetchReassignablePeople()
          this.isLoading = false
        }
      },
    },
  },

  methods: {
    clearDeletePersonForm(): void {
      this.userIDToReassignItemsTo = null
      this.deleteConfirmed = false
      this.internalShowModal = false
    },
    async fetchReassignablePeople() {
      try {
        this.reassignablePeople = await AccountMembershipsAPI.get_ReassignmentOptions(
          this.person.accountMembershipID,
        )
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async deletePerson() {
      try {
        this.isDeletingPerson = true
        const response = await AccountMembershipsAPI.post_Delete(
          this.person.accountMembershipID,
          this.userIDToReassignItemsTo,
        )
        this.clearDeletePersonForm()
        this.$messaging.showSuccess(response.message)
        await this.$nextTick()
        this.$emit('person-deleted') // Move route assitant to caller nextr...
      } catch (error) {
        this.$error.emit(error)
      } finally {
        this.isDeletingPerson = false
      }
    },
  },
})
